import React from 'react';
import OpSecToggle from './OpSecToggle';
import FreeAccessCard from './FreeAccessCard';
import ClearTTSCacheButton from './ClearTTSCacheButton';

const StatCard = ({ label, value, testId }) => (
  <div className="bg-zinc-900/80 backdrop-blur-xl border border-red-900/30 rounded-lg p-6" data-testid={testId}>
    <p className="text-gray-400 text-sm font-medium mb-2">{label}</p>
    <p className="text-4xl font-black text-white">{Number(value).toLocaleString()}</p>
  </div>
);

const OverviewTab = ({ analytics, token }) => {
  if (!analytics) return null;

  return (
    <div data-testid="overview-tab" className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard label="Total Page Views" value={analytics.overview.total_views} testId="stat-total-views" />
        <StatCard label="Unique Visitors" value={analytics.overview.unique_visitors} testId="stat-unique-visitors" />
        <StatCard label="Newsletter Subscribers" value={analytics.overview.total_subscribers} testId="stat-subscribers" />
        <StatCard label="PWA Installs" value={analytics.overview.total_installs ?? analytics.overview.total_downloads} testId="stat-pwa-installs" />
      </div>

      <FreeAccessCard token={token} />

      <OpSecToggle token={token} />

      <ClearTTSCacheButton token={token} />

      <div className="bg-zinc-900/80 backdrop-blur-xl border border-red-900/30 rounded-lg p-6">
        <h3 className="text-xl font-black text-white mb-4">PWA Install Breakdown</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-gray-400 text-sm mb-1">Unique Installs</p>
            <p className="text-3xl font-black text-green-400">{(analytics.install_breakdown ?? analytics.download_breakdown).unique}</p>
          </div>
          <div>
            <p className="text-gray-400 text-sm mb-1">Repeat Installs</p>
            <p className="text-3xl font-black text-yellow-400">{(analytics.install_breakdown ?? analytics.download_breakdown).repeat}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
